module.exports = __webpack_public_path__ + "media/lookbook_1.7669ad3d.mp4";